module.exports = __webpack_public_path__ + "9366e04f31f1b9d93caefe21309731d9.svg";